import { JSONObject } from "../services";

const HISTORY_METADATA_KEYS = [
  "historyCreatedTime",
  "actionPerformed",
  "historyId",
  "historyVersion",
  "modifiedBy",
  "modifiedAt",
  "createdAt",
  "updatedAt",
  "version",
  "versionId",
  "lastModified",
  "lastModifiedBy",
];

export class DataCleaner {
  static removeHistoryMetadata(data: JSONObject | null): JSONObject | null {
    if (!data) {
      return null;
    }

    const cleaned: JSONObject = {};
    for (const [key, value] of Object.entries(data)) {
      if (!HISTORY_METADATA_KEYS.includes(key)) {
        cleaned[key] = value;
      }
    }
    return cleaned;
  }
}
